export default "__VITE_ASSET__DgNjlq9S__"